module.exports = __webpack_public_path__ + "img/50.6.CODm.591389b4.png";